angular.module('picmonicng').directive('twitterButton', [
  function () {
    return {
      restrict: 'E',
      link: function (scope, element, attrs) {
        element.on('click', function () {
          var url = escape(attrs.url);
          var text = escape(attrs.text);

          window.open(
            'https://twitter.com/share?url=' + url + '&text=' + text + '&',
            'twitterwindow',
            'height=450, width=550, top=' +
              ($(window).height() / 2 - 225) +
              ', left=' +
              $(window).width() / 2 +
              ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0'
          );

          send_ga('event', 'Referral', 'Twitter Button Clicked');
        });
      },
    };
  },
]);
